import { assert, Listeners, UUID } from "@opendaw/lib-std";
export class BoxAdapterCollection {
    #entries;
    #listeners;
    #subscription;
    constructor(pointerHub, provider, pointers) {
        this.#entries = UUID.newSet(adapter => adapter.uuid);
        this.#listeners = new Listeners();
        this.#subscription = pointerHub.catchupAndSubscribe({
            onAdded: (pointer) => {
                const adapter = provider(pointer.box);
                const added = this.#entries.add(adapter);
                assert(added, `Could not add ${adapter}`);
                this.#listeners.proxy.onAdd(adapter);
            },
            onRemoved: (pointer) => {
                const uuid = pointer.box.address.uuid;
                this.#listeners.proxy.onRemove(this.#entries.removeByKey(uuid));
            }
        }, pointers);
    }
    subscribe(listener) { return this.#listeners.subscribe(listener); }
    catchupAndSubscribe(listener) {
        this.#entries.forEach(adapter => listener.onAdd(adapter));
        return this.subscribe(listener);
    }
    adapters() { return this.#entries.values(); }
    size() { return this.#entries.size(); }
    isEmpty() { return this.size() === 0; }
    terminate() {
        this.#entries.clear();
        this.#listeners.terminate();
        this.#subscription.terminate();
    }
}
